import { request } from '@/utils/axios/index.ts'
import type { ResponseData, RequestData, Page, Field } from '@/utils/axios/base_vo.ts'
import { toListArgs } from '@/utils/axios/list.ts'

export interface CustomApp {
    id?: string //
    deleted?: string // 状态（1：删除，0：正常）
    revision?: number // 乐观锁
    created_by?: string // 创建人
    created_by_name?: string //
    created_time?: string // 创建时间
    updated_by?: string // 修改人
    updated_by_name?: string //
    updated_time?: string // 修改时间
    custom_type?: string // channel、org
    custom_id?: string // 渠道商、企业id
    app_name?: string // 应用名称
    app_logo?: string // 应用logo
    app_namespace_prefix?: string // 应用域名前缀
    app_logo_url?: string // 应用logo跳转地址
    allow_wechat_login?: boolean // 是否允许微信登录
    app_ico_url?: string // 应用网站ico图标
}

export async function custom_app_list(
    params: any,
    sort?: Record<string, 'descend' | 'desc' | 'asc' | 'ascend'>,
    field?: Field,
    page?: Page
) {
    const requestData: RequestData<CustomApp> = toListArgs(params, sort, field, page)
    return await request.post<ResponseData<CustomApp[]>>('/3/t_user/custom_app/list', requestData)
}

export async function custom_app_item(params: any) {
    return await request.post<ResponseData<CustomApp>>('/3/t_user/custom_app/item', { data: params })
}

export async function custom_app_add(params: any) {
    return await request.post<ResponseData<CustomApp>>('/3/t_user/custom_app/add', { data: params })
}

export async function custom_app_edit(row: any, params: any) {
    return await request.post<ResponseData<CustomApp>>('/3/t_user/custom_app/edit', {
        data: Object.assign(row, params)
    })
}

export async function custom_app_del(params: any) {
    return await request.post<ResponseData<CustomApp>>('/3/t_user/custom_app/del', { data: params })
}
